// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3fc29ad5","160":"100c27af","395":"2aeb09f4","466":"6f979b68","638":"7bbb3f5a","738":"3261672d"}[chunkId] + ".chunk.js";
};